import { Stack } from '@fluentui/react';
import React from 'react';
import {
  TravelerAvailableTags,
  TravelerAvailableTagsVariables,
} from 'common/graphql/__generated__/TravelerAvailableTags';
import {
  TravelerTags,
  TravelerTagsVariables,
} from 'common/graphql/__generated__/TravelerTags';
import {
  EntityTagTravelerCreate,
  EntityTagTravelerCreateVariables,
} from 'common/graphql/__generated__/EntityTagTravelerCreate';
import {
  EntityTagDelete,
  EntityTagDeleteVariables,
} from 'common/graphql/__generated__/EntityTagDelete';
import { EntityTagInput } from 'common/types/globalTypes';
import { useStyles } from 'common/components/ActionMenu/Tags/index.styles';
import { EntityTagsSection } from 'common/components/ActionMenu/Tags';

import TRAVELER_AVAILABLE_TAGS from 'common/graphql/TravelerAvailableTags.graphql';
import TRAVELER_TAGS from 'common/graphql/TravelerTags.graphql';
import ENTITY_TAG_TRAVELER_CREATE from 'common/graphql/EntityTagTravelerCreate.graphql';
import ENTITY_TAG_DELETE from 'common/graphql/EntityTagDelete.graphql';

interface TagsProps {
  travelerId: string;
}

export const Tags: React.FC<TagsProps> = ({ travelerId }) => {
  const styles = useStyles();

  const extractAvailableTags = (data: TravelerAvailableTags | undefined) => {
    return (
      data?.travelerAvailableTags?.nodes.map((tag) => ({
        id: tag.id,
        badgeName: tag.badgeName,
        badgeColor: tag.badgeColor ?? undefined,
      })) ?? []
    );
  };

  const extractEntityTags = (data: TravelerTags | undefined) => {
    return (
      data?.traveler?.entityTagsByEntityId.nodes.map((tag) => ({
        id: tag.id,
        _rowTimestamp: tag._rowTimestamp!,
        _tagBadgeName: tag._tagBadgeName!,
        _tagBadgeColor: tag._tagBadgeColor ?? undefined,
        _createdDate: tag._createdDate!,
        createdByUser: tag.createdByUser ?? 'Unknown',
      })) ?? []
    );
  };

  const getAvailableTagsVars = (
    entityId: string
  ): TravelerAvailableTagsVariables => ({
    id: entityId,
  });

  const getEntityTagsVars = (entityId: string): TravelerTagsVariables => ({
    id: entityId,
  });

  const createTagsVars = (
    tags: EntityTagInput[]
  ): EntityTagTravelerCreateVariables => ({
    input: {
      entityTag: tags,
    },
  });

  const deleteTagsVars = (
    id: string,
    rowTimestamp: string
  ): EntityTagDeleteVariables => ({
    entityTagDeleteInput: {
      entityDelete: [{ id, rowTimestamp }],
    },
  });

  return (
    <Stack tokens={{ childrenGap: 15 }} className={styles.tagsContainer}>
      <EntityTagsSection<
        TravelerAvailableTags,
        TravelerAvailableTagsVariables,
        TravelerTags,
        TravelerTagsVariables,
        EntityTagTravelerCreate,
        EntityTagTravelerCreateVariables,
        EntityTagDelete,
        EntityTagDeleteVariables
      >
        entityId={travelerId}
        getAvailableTagsGql={TRAVELER_AVAILABLE_TAGS}
        getEntityTagsGql={TRAVELER_TAGS}
        addTagGql={ENTITY_TAG_TRAVELER_CREATE}
        deleteTagGql={ENTITY_TAG_DELETE}
        extractAvailableTags={extractAvailableTags}
        extractEntityTags={extractEntityTags}
        getAvailableTagsVars={getAvailableTagsVars}
        getEntityTagsVars={getEntityTagsVars}
        createTagsVars={createTagsVars}
        deleteTagsVars={deleteTagsVars}
      />
    </Stack>
  );
};
